// NPM Imports
import React from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Utility Imports
import { GlobalUtils } from "../../../utils/index";

const AssetDetailsModal = props => {
  // Destructuring props
  const {
    name: opportunityName,
    stage_name: crmStage,
    expected_revenue: expectedRevenue,
    created_at: oppStartDate,
    close_date: oppCloseDate,
    updated_at: updateDate,
    amount: netAmount,
    fiscal_quarter: fiscalQuarter,
    fiscal_year: fiscalYear,
    source: leadSource,
    quote_status: quoteStatus,
    crm_account: { name: accountName } = {},
    owner: { name: ownerName } = {},
  } = props.opportunity;

  return (
    <Modal
      open={props.show}
      onClose={props.closePopup}
      closeOnOverlayClick={false}
      center>
      <div className="assetdetailsmodal-wrapper">
        <div className="assetdetailsmodal-heading">
          <i>
            <FontAwesomeIcon icon={["far", "crown"]} />
          </i>
          {opportunityName}
        </div>
        <div className="assetdetailspopup-row">
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Account</span>
            <span className="assetdetailspopup-title">
              {accountName || "-"}
            </span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Owner</span>
            <span className="assetdetailspopup-title">{ownerName || "-"}</span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Lead Source</span>
            <span className="assetdetailspopup-title">{leadSource || "-"}</span>
          </div>
        </div>
        <div className="assetdetailspopup-row">
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">CRM Stage</span>
            <span className="assetdetailspopup-title">{crmStage}</span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Quote Status</span>
            <span className="assetdetailspopup-title">{quoteStatus}</span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Net Amount</span>
            <span className="assetdetailspopup-title">${netAmount}</span>
          </div>
        </div>
        <div className="assetdetailspopup-row">
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Fiscal Quarter</span>
            <span className="assetdetailspopup-title">{fiscalQuarter}</span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Fiscal Year</span>
            <span className="assetdetailspopup-title">{fiscalYear}</span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">
              Expected Revenue
            </span>
            <span className="assetdetailspopup-title">${expectedRevenue}</span>
          </div>
        </div>
        <div className="assetdetailspopup-row">
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Start Date</span>
            <span className="assetdetailspopup-title">
              {GlobalUtils.formatDate(oppStartDate, "ll")}
            </span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Close Date</span>
            <span className="assetdetailspopup-title">
              {GlobalUtils.formatDate(oppCloseDate, "ll")}
            </span>
          </div>
          <div className="assetdetailspopup-title-wrapper">
            <span className="assetdetailspopup-metatitle">Updated Date</span>
            <span className="assetdetailspopup-title">
              {GlobalUtils.formatDate(updateDate, "ll")}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AssetDetailsModal;
